import Vue from 'vue';
import Router from 'vue-router';

import store from './store';

const NotFound = () => Promise.resolve(import('./views/NotFound.vue'));
const Error500 = () => Promise.resolve(import('./views/Error500.vue'));
const Error502 = () => Promise.resolve(import('./views/Error502.vue'));
const Error503 = () => Promise.resolve(import('./views/Error503.vue'));
const Tickets = () => Promise.resolve(import('./views/Tickets.vue'));
const Welcome = () => Promise.resolve(import('./views/Welcome.vue'));
const Verify = () => Promise.resolve(import('./views/Verify.vue'));
const VisanetError = () => Promise.resolve(import('./views/VisanetError.vue'));
// const VerifyRepayment = () => Promise.resolve(import('./views/VerifyRepayment.vue'));

// import Menu from './views/Menu.vue';
const Menu = () => Promise.resolve(import('./views/LandingFPF.vue'));
const Detail = () => Promise.resolve(import('./views/Detail.vue'));
const DetailMobile = () => Promise.resolve(import('./views/DetailMobile.vue'));
const DetailReservate = () => Promise.resolve(import('./views/DetailReservate.vue'));
const Landing = () => Promise.resolve(import('./views/Landing.vue'));
const Login = () => Promise.resolve(import('./views/Login.vue'));
const LoginDetail = () => Promise.resolve(import('./views/LoginDetail.vue'));
const Inscripcion = () => Promise.resolve(import('./views/Inscripcion.vue'));
const VerifyInscription = () => Promise.resolve(import('./views/VerifyInscription.vue'));
const VerifyWinner = () => Promise.resolve(import('./views/VerifyWinner.vue'));
const VerifyTicket = () => Promise.resolve(import('./views/VerifyTicket.vue'));
const AlianzaLima = () => Promise.resolve(import('./views/AlianzaLima.vue'));
const Lima42k = () => Promise.resolve(import('./views/Adidas.vue'));

const dataGeneral = require('../data/dataGeneral.json');

const { disableSale } = dataGeneral;

Vue.use(Router);

const routerList = [
  {
    path: '/inscripcion',
    name: 'Inscripcion',
    component: Inscripcion,
    beforeEnter(to, from, next) {
      /* if (!store.state.auth.token) {
        next({ name: 'Login', query: { redirect: to.fullPath } });
      }
      next(); */
      next({ name: 'VerifyWinnerNew' });
    },
  },
  {
    path: '/editar-inscripcion',
    name: 'InscripcionEdit',
    component: Inscripcion,
    beforeEnter(to, from, next) {
      /* if (!store.state.auth.token) {
        next({ name: 'Login', query: { redirect: to.fullPath } });
      }
      next(); */
      next({ name: 'VerifyWinnerNew' });
    },
  },
  {
    path: '/verificar-ganador',
    name: 'VerifyWinner',
    component: VerifyWinner,
    beforeEnter(to, from, next) {
      next({ name: 'VerifyWinnerNew' });
    },
  },
  {
    path: '/verifica-ganador',
    name: 'VerifyWinnerNew',
    component: VerifyWinner,
    beforeEnter(to, from, next) {
      if (!store.state.auth.token) {
        next({ name: 'Login', query: { redirect: to.fullPath } });
      }
      next();
    },
  },
  {
    path: '/verificar-inscripcion',
    name: 'VerifyInscription',
    component: VerifyInscription,
    beforeEnter(to, next) {
      // if (!store.state.auth.token) {
      //   next({ name: 'Login', query: { redirect: to.fullPath } });
      // }
      next({ name: 'VerifyWinnerNew' });
    },
  },
  {
    path: '/fpf',
    name: 'Fpf',
    component: Menu,
  },
  {
    path: '/alianza-lima',
    name: 'AlianzaLima',
    component: AlianzaLima,
  },
  {
    path: '/lima42k',
    name: 'Lima42k',
    component: Lima42k,
    beforeEnter(to, from, next) {
      if (!store.state.auth.token) {
        next({ name: 'Login', query: { redirect: to.fullPath } });
      }
      next();
    },
  },
  {
    path: '/',
    name: 'Home',
    component: Welcome,
    beforeEnter: (to, from, next) => {
      const { hostname } = window.location;
      if (hostname === 'alianza.joinnus.com') {
        next({ path: '/detail/cristal' });
      } else if (hostname === 'deventradas.joinnus.com') {
        next({ name: 'Karolg' });
      } else if (hostname === 'fpf.joinnus.com') {
        next({ name: 'Fpf' });
      } else if (hostname === 'ricardoarjona.joinnus.com') {
        next({ name: 'Arjona' });
      } else if (hostname === 'karolg.joinnus.com') {
        next({ name: 'Karolg' });
      } else {
        next();
        // window.location.href = 'https://www.joinnus.com/';
      }
    },
  },
  // {
  //   path: '/reserva/:id?',
  //   name: 'Reservate',
  //   component: Reservate,
  // },
  {
    path: '/visanet-error',
    name: 'VisanetError',
    component: VisanetError,
  },
  {
    path: '/visanet-error/:slug',
    name: 'VisanetErrorSlug',
    component: VisanetError,
  },
  // {
  //   path: '/devoluciones',
  //   name: 'verifyRepayment',
  //   component: VerifyRepayment,
  // },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter(to, from, next) {
      if (store.state.auth.token) {
        const { redirect } = to.query;
        const { hostname } = window.location;
        if (redirect) {
          next({ path: redirect });
        } else if (hostname === 'alianza.joinnus.com') {
          next({ path: '/detail/cristal' });
        } else if (hostname === 'deventradas.joinnus.com') {
          next({ name: 'Karolg' });
        } else if (hostname === 'fpf.joinnus.com') {
          next({ name: 'Fpf' });
        } else if (hostname === 'arjona.joinnus.com') {
          next({ name: 'Arjona' });
        } else if (hostname === 'karolg.joinnus.com') {
          next({ name: 'Karolg' });
        } else {
          window.location.href = 'https://www.joinnus.com/';
        }
      }
      next();
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter(to, from, next) {
      const { redirect } = to.query;
      store.dispatch('logout');
      next({ name: 'Login', query: { redirect } });
    },
  },
  {
    path: '/entradas/:id/:slug?/:code?',
    name: 'Tickets',
    component: Tickets,
    // beforeEnter(to, from, next) {
    //   if (!store.state.auth.token) {
    //     next({ name: 'Login', query: { redirect: to.fullPath } });
    //   }
    //   next();
    // },
  },
  {
    path: '/gracias-por-tu-compra/:id/:slug',
    name: 'VerifyTicket',
    component: VerifyTicket,
  },
  {
    path: '/500',
    name: 'Error500',
    component: Error500,
  },
  {
    path: '/502',
    name: 'Error502',
    component: Error502,
  },
  {
    path: '/503',
    name: 'Error503',
    component: Error503,
  },
  {
    path: '*',
    name: 'Error404',
    component: NotFound,
  },
];

if (!disableSale) {
  routerList.push(
    {
      path: '/canje/:slug?',
      name: 'Welcome',
      component: Welcome,
    },
    {
      path: '/verificar/:id?/:slug?',
      name: 'Verify',
      component: Verify,
    },
    {
      path: '/detail/:slug',
      name: 'Detail',
      component: async () => {
        if (!store.state.auth.token) {
          return (await LoginDetail()).default;
        }
        return (await Detail()).default;
      },
      beforeEnter(to, from, next) {
        if (to.path === '/detail/lima42k') {
          next({ name: 'Lima42k' });
        }
        /* if (!store.state.auth.token) {
          next({ name: 'Login', query: { redirect: to.fullPath } });
        } */
        next();
      },
    },
    {
      path: '/mobile/detail/:slug',
      name: 'DetailMobile',
      component: DetailMobile,
      // beforeEnter(to, from, next) {
      //   if (to.path === '/detail/lima42k') {
      //     next({ name: 'Lima42k' });
      //   }
      //   if (!store.state.auth.token) {
      //     next({ name: 'Login', query: { redirect: to.fullPath } });
      //   }
      //   next();
      // },
    },
    {
      path: '/detail/:slug/:id?',
      name: 'DetailReservate',
      component: DetailReservate,
      beforeEnter(to, from, next) {
        if (!store.state.auth.token) {
          next({ name: 'Login', query: { redirect: to.fullPath } });
        }
        next();
      },
    },
    {
      path: '/detail/:slug/reservation/:id?',
      name: 'DetailReservation',
      component: DetailReservate,
      beforeEnter(to, from, next) {
        if (!store.state.auth.token) {
          next({ name: 'Login', query: { redirect: to.fullPath } });
        }
        next();
      },
    },
    {
      path: '/landing/:slug',
      name: 'Landing',
      component: Landing,
    },
  );
}

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL || '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: routerList,
});

export default router;
